export default {
    'categories.activities': 'Aktiviteter',
    'categories.animals-nature': 'Dyr & natur',
    'categories.custom': 'Tilpasset',
    'categories.flags': 'Flagg',
    'categories.food-drink': 'Mat & drikke',
    'categories.objects': 'Objekter',
    'categories.people-body': 'Mennesker & kropp',
    'categories.recents': 'Nylig brukte',
    'categories.smileys-emotion': 'Smilefjes & følelser',
    'categories.symbols': 'Symboler',
    'categories.travel-places': 'Reise & steder',
    'error.load': 'Klarte ikke laste inn emojis',
    'recents.clear': 'Fjern nylige emojis',
    'recents.none': 'Du har ikke valgt noen emojis enda.',
    'retry': 'Prøv igjen',
    'search.clear': 'Tøm søk',
    'search.error': 'Klarte ikke å søke etter emojis',
    'search.notFound': 'Ingen emojis funnet',
    'search': 'Søk etter emojis...'
  };
  